/**
 * Shared post-auth Vuex + destination for Login, Forgot redeem, and Kickoff.
 * Same session fields as POST /api/user/login/ so gates (EULA / phone / employer) stay identical.
 */
import { resolvePostLoginTarget } from './mobile/standaloneLaunch'

export function applyAuthSession (store, data) {
  store.commit('logout')
  store.commit('setToken', data.token)
  store.commit('setUserData', {
    email: data.email,
    id: data.id,
    accepted_eula: data.accepted_eula,
    force_password_reset: data.force_password_reset,
    can_import_csv: data.can_import_csv,
    can_import_org: data.can_import_org,
    can_import_org_allowed: data.can_import_org_allowed,
    can_edit_golden_record: data.can_edit_golden_record,
    can_admin_gtm: data.can_admin_gtm,
    can_tuba_blast: !!data.can_tuba_blast,
    has_gtm_play_seat: !!data.has_gtm_play_seat,
    has_my_gtms: !!data.has_my_gtms,
    needs_employer: !!data.needs_employer,
    needs_phone_proof: !!data.needs_phone_proof,
  })
}

export function postAuthDestination (data, query) {
  if (!data.accepted_eula) return '/eula'
  if (data.force_password_reset) return '/change_password'
  if (data.needs_phone_proof) return '/kickoff'
  if (data.needs_employer) return '/profile'
  return resolvePostLoginTarget(query, '/landing')
}
